// Service
import { extendCustomerSessionLifeService } from 'services/extend-session.service';

const extendCustomerSessionLifeResolver = async (): Promise<[number]> => {
  const [, { status }] = await extendCustomerSessionLifeService();

  return [status];
};

export { extendCustomerSessionLifeResolver };
